module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "sp",
    attrs: {
      "id": "sai"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "EPVT"
  }, [_vm._v("THE SAIL")]), _vm._v(" "), _c('p', {
    staticClass: "EPV"
  }, [_vm._v("A white sail gleams alone out yonder")]), _vm._v(" "), _c('p', {
    staticClass: "EPV"
  }, [_vm._v("Amid the ocean’s pale-blue haze … ")]), _vm._v(" "), _c('p', {
    staticClass: "EPV"
  }, [_vm._v("What quest has driven him to wander?")]), _vm._v(" "), _c('p', {
    staticClass: "EPV"
  }, [_vm._v("Why has he left his native bays?")]), _vm._v(" "), _c('p', {
    staticClass: "EPV-SB"
  }, [_vm._v("The waves crest as the fresh wind rises,")]), _vm._v(" "), _c('p', {
    staticClass: "EPV"
  }, [_vm._v("The mainmast bending in the breeze … ")]), _vm._v(" "), _c('p', {
    staticClass: "EPV"
  }, [_vm._v("It is not happiness he prizes,")]), _vm._v(" "), _c('p', {
    staticClass: "EPV"
  }, [_vm._v("Nor is it happiness he flees!")]), _vm._v(" "), _c('p', {
    staticClass: "EPV-SB"
  }, [_vm._v("Beneath, the azure current flowing;")]), _vm._v(" "), _c('p', {
    staticClass: "EPV"
  }, [_vm._v("Above, the golden sunlight glows … ")]), _vm._v(" "), _c('p', {
    staticClass: "EPV"
  }, [_vm._v("Perverse, he seeks the storm winds blowing,")]), _vm._v(" "), _c('p', {
    staticClass: "EPV"
  }, [_vm._v("As if in storms to find repose!")]), _vm._v(" "), _c('p', {
    staticClass: "EPVS"
  }, [_vm._v("—Mikhail Lermontov; translated by Alan Myers")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3709ba74","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/sail.vue
// module id = 75
// module chunks = 0